import { PetController } from '../../../../../../services/controllers/global';
import { PageVisibilityAction } from '../../../../../../components/PageVisibilityAction';

import { Container } from './styles';

export function IncompleteRegistration({ content, petId }) {
  const CLPet = petId ? PetController(petId) : null;

  return (
    <>
      {CLPet && <PageVisibilityAction onVisibility={CLPet.getPet} />}
      <Container dangerouslySetInnerHTML={{ __html: content }} />
    </>
  );
}
